<div class="container-fluid  h-100" >
  <app-loader></app-loader>
<mat-toolbar class="d-flex  justify-content-between mat-toolbar" 
 >
  <div class="d-flex">      
    <img src="assets/img/RockefellerLogoBlackBG.svg"  alt="Rockfeller logo" >
   <div class="css-fzmnxl"></div>
    <div class="fs-6 d-flex align-items-center fontClass">AML PERIODIC CLIENT REVIEW</div>
    

  </div>
  <div *ngIf="isHome" style="column-gap: 10px;" class="d-flex ">  
         
    <div   class="" style="display: flex;">
      <mat-icon style="font-size: 22px !important" class="pointer m-r-10" inline="true"
        [matMenuTriggerFor]="advTreeMenu" #advMenuTrigger="matMenuTrigger">
        groups
      </mat-icon>
    </div>
    <span class="fontClass">{{ loggedInUser?.name }}  </span>
   
    <mat-icon *ngIf="showUserSel"  style="font-size: 18px !important" class="pointer" [matMenuTriggerFor]="superMenu"
      inline="true">more_vert</mat-icon>
    
  </div>
</mat-toolbar>




  <!-- Advsor Tree - menu-->
  <mat-menu #advTreeMenu="matMenu" class="advTree-menu">
    <ng-template matMenuContent>
      <div class="flex-col-container m-10" (click)="$event.stopPropagation()">
        <app-advisors-tree-filter *ngIf="advTree.length" [AdvisorsTreeData]="advTree" [SelectedRepIds]="repIds"
          (OnAppliedFilter)="advListChanged($event)" (cancelFilter)="closeAdvTree()">
        </app-advisors-tree-filter>
      </div>
    </ng-template>
  </mat-menu>
 
<!-- <button mat-icon-button (click)="sidenav.toggle()">
  <mat-icon style="color: #005CB8;">filter_list</mat-icon>
</button> -->




  <mat-menu  class=" pe-3 ps-3 bg-white" #superMenu="matMenu" >
    <div class=""   (click)="$event.stopPropagation()">
      <mat-radio-group [(ngModel)]="tempRole" class=" " (click)="$event.stopPropagation()">
        <mat-radio-button value="SUPER" (click)="$event.stopPropagation()">SUPER</mat-radio-button>
      
        <mat-radio-button value="AML"  (click)="$event.stopPropagation()">AML</mat-radio-button>
        <mat-radio-button value="DBD" (click)="$event.stopPropagation()">DS</mat-radio-button>
        <mat-radio-button value="PA"  (click)="$event.stopPropagation()">PA/CA</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="d-flex pt-2 justify-content-start align-bottom">
      <button  mat-stroked-button color="Primary" class="me-1 amlbuttonbackgroundnoborder" >Cancel</button>
      <button  mat-stroked-button color="accent" class="amlbuttonbackground"  (click)="changeUser()">Apply</button>
    </div>
  </mat-menu>


<div >
    <router-outlet  class="w3-animate w3-animate-right"></router-outlet>
</div>

</div>